import { useEffect, useRef } from 'react';

export default function useMountEffect(event: () => void) {
  const mounted = useRef(false);

  useEffect(() => {
    if (mounted.current) return;
    mounted.current = true;
    event();
    // eslint-disable-next-line
  }, []);
}
